<script setup lang="ts">
defineProps<{
  event: EventCard
  tag: 'h1' | 'h2' | 'h3'
}>()
</script>

<template>
  <component :is="tag" :class="{ 'font-headline text-4xl sm:text-6xl': tag === 'h1' }">
    {{ event.title }}
  </component>
</template>
